export default "__VITE_ASSET__D6WOYE7v__"